import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-licenses-license',
    templateUrl: './licenses-license.component.html',
    styleUrls: ['./licenses-license.component.scss'],
    standalone: false
})
export class LicensesLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
